import React from 'react';
import PropTypes from 'prop-types';

import { extractCallbacksFromProps } from 'ggApp/modules/tracking/hocs/withListEventHandlers';
import { HandPickedProductCardWithTracking } from 'ggApp/shared/components/cards/handPickedProductCard';
import { Card as WidgetProductCard } from 'ggApp/shared/components/cards/widgetProductCard';
import DisplayIf from 'ggApp/shared/components/viewport';

export default class HandPickedProductWidget extends React.PureComponent {
    render() {
        const {
            className,
            product,
            accentColor,
            productImpressionCallbacks,
            goToProductPage,
            testId,
        } = this.props;

        const DesktopView = (
            <HandPickedProductCardWithTracking
                product={product}
                accentColor={accentColor}
                onClick={goToProductPage}
                {...extractCallbacksFromProps(productImpressionCallbacks, 0)}
            />
        );
        const MobileView = (
            <WidgetProductCard
                key={product.slug}
                product={product}
                cardType="vertical"
                {...extractCallbacksFromProps(productImpressionCallbacks, 0)}
                handpickedProduct
            />
        );
        if (!product) return null;
        return (
            <div className={className} data-testid={testId}>
                <DisplayIf tablet desktop largeDesktop widescreen>
                    {DesktopView}
                </DisplayIf>
                <DisplayIf mobile>{MobileView}</DisplayIf>
            </div>
        );
    }
}

HandPickedProductWidget.propTypes = {
    product: PropTypes.shape({}),
    className: PropTypes.string,
    productImpressionCallbacks: PropTypes.arrayOf(PropTypes.func),
    onClick: PropTypes.func,
};

HandPickedProductWidget.defaultProps = {
    product: null,
    className: '',
    productImpressionCallbacks: undefined,
    onClick: () => null,
};
